const $inject = ['$q', '$injector', '$rootScope', '$window', 'currentUserService', 'AUTH_EVENTS', 'APP_CONFIG'];

const requestInterceptor = function($q, $injector, $rootScope, $window, currentUserService, AUTH_EVENTS, APP_CONFIG) {
  let factory = {};
  factory.request = request;
  factory.response = response;
  factory.responseError = responseError;

  let inFlightAuthRequest = null;

  function isAPI(url) {
    return url.startsWith(APP_CONFIG.api.url) || url.startsWith(APP_CONFIG.api.sctApiUrl);
  }

  function request(config) {
    if (config.params) {
      const keys = ['q', 'query', 'departmentCode', 'term']
      const reg = /[^A-Za-z '@,\-.0-9]+/g;
      
      Object.keys(config.params).forEach(key => {
        if (keys.includes(key))
          config.params[key] = config.params[key].replace(reg, '');
      })
    }

    let authService = $injector.get('authService');
    let accessToken = authService.getAccessToken();

    if(isAPI(config.url)) {
      if(!config.isPublic) {
        if (accessToken) {
          config.headers.Authorization = 'Bearer ' + accessToken;
        } else {
          $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
        }
      }

      const debtor = currentUserService.get('debtor');

      if(debtor) {
        config.headers['X-Api-Debtor'] = debtor.Name;
      }

      if($rootScope.enableDebug) {
        config.headers['X-Api-Enable-Debug'] = true;
      }

      if(config.apiVersion) {
        config.headers['X-api-version'] = config.apiVersion;
      }
    }

    return config;
  }

  function response(response) {
    if(isAPI(response.config.url)) {
      const headers = response.headers();
      const debugActivityId = headers['x-api-debug-activityid'];

      if(debugActivityId) {
        $window.LB_DEBUG = $window.LB_DEBUG || [];
        $window.LB_DEBUG.push({
          activityId: debugActivityId,
          requestUrl: response.config.url,
          responseTime: new Date(Date.now()).toString()
        });
      }
    }

    return response;
  }

  function responseError(rejection) {
    const deferred = $q.defer();

    if (rejection.status === 401) {
      let authService = $injector.get('authService');
      let refreshToken = authService.getRefreshToken();

      if (refreshToken) {
        if(!inFlightAuthRequest) {
          inFlightAuthRequest = authService.refresh(refreshToken);
        }

        inFlightAuthRequest.then(function () {
          inFlightAuthRequest = null;
          const $http = $injector.get('$http');
          return deferred.resolve($http(rejection.config));
        }, function () {
          inFlightAuthRequest = null;

          authService.logout().then(function() {
            $rootScope.$broadcast(AUTH_EVENTS.logoutSuccess);
          });
        });
      }
      else {
        $rootScope.showLoader = false;
        $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
      }
    }

    if(rejection.status >= 500 || rejection.status === 417) {
      $rootScope.showLoader = false;

      $rootScope.$broadcast('httpError', {
        rejection: rejection
      });

      /*
      TRY AGAIN:
      const $http = $injector.get('$http');
      deferred.resolve($http(rejection.config));
      */
    }

    if(rejection.status === 412) {
      const newRejection = _.extend({}, rejection, {
        data: {
          Message: 'Sorry, another admin has made a change',
          Instructions: 'To avoid conflicting changes we\'re going to fetch the latest configuration and refresh your browser.'
        }
      });

      $rootScope.showLoader = false;

      $rootScope.$broadcast('httpError', {
        rejection: newRejection,
        warnLevel: 'info'
      }, () => {
        $window.location.reload();
      });

      rejection.data.errorIntercepted = true;
    }

    if(rejection.status === 422) {
      rejection.data = {
        OriginalMessage: rejection.data,
        Message: 'We were unable to update your cart',
        Instructions: 'Please refresh your browser and try again.'
      };

      $rootScope.showLoader = false;

      $rootScope.$broadcast('httpError', {
        rejection: rejection,
        warnLevel: 'info'
      });
    }
	
	if(rejection.status === 400) {
      rejection.data = {
        OriginalMessage: rejection.data,
        Message: 'There was a problem with your request.',
        Instructions: rejection.data.Message
      };

      $rootScope.showLoader = false;

      $rootScope.$broadcast('httpError', {
        rejection: rejection,
        warnLevel: 'info'
      });
    }

    if(rejection.status === 404) {
      $rootScope.$broadcast('httpError', {
        rejection: rejection
      });

      $rootScope.$emit('404Error');
    }

    return $q.reject(rejection);
  }

  return factory;
};

requestInterceptor.$inject = $inject;

export default requestInterceptor;



// WEBPACK FOOTER //
// ./src/factories/requestInterceptor.js